import { PaymentDetailsModel } from "model/PaymentDetails.model";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = PaymentDetailsModel | null;

export const useDefaultObservablePaymentDetailsModelNull = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectPaymentDetailsModelNull extends BehaviorSubject<CurrentType> {}
